import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { createContext as n, forwardRef as f } from "react";
const m = n({ radioName: "" }), c = f(
  ({ legend: d, children: s, name: r, className: t = "", showLegend: a = !1, ...i }, l) => /* @__PURE__ */ e(m.Provider, { value: { radioName: r }, children: /* @__PURE__ */ o("fieldset", { "data-testid": "fieldset", ...i, className: `rds-field-set ${t}`, ref: l, children: [
    /* @__PURE__ */ e("legend", { className: `rds-field-set__legend ${a ? "" : "sr-only"}`, children: d }),
    s
  ] }) })
);
c.displayName = "FieldSet";
export {
  c as F,
  m as R
};
